export const formatNumberToEuropean = (value: string | number): string => {
  return value.toString().replaceAll('.', ',')
}
